import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import type { JSX } from 'react';
import { useFormContext } from 'react-hook-form';

import { TextFormField } from '~components/FormFields/TextFormField';

import type { ProjectFormSchemaInterface } from '../../projectFormSchema';

// Mirrors the legacy form — the per-project override of the
// company-wide Quote PDF terms. Render-only by design: a plain multiline
// field over `projectTerms`; the schema default and the dirty-gated update
// deparse live elsewhere, so this panel is only the render layer. One
// deviation: `my: 2` instead of legacy's `mb: 2`, because the shared
// <Notes/> card above sets no bottom margin and the two cards would
// otherwise sit flush.
export function QuotePdfTermsPanel(): JSX.Element {
  const { control, formState } = useFormContext<ProjectFormSchemaInterface>();

  return (
    <Card sx={{ p: 2, my: 2 }}>
      <Typography variant="form-section-title" sx={{ mb: 1 }}>
        {t('project.form.quote_pdf_terms')}
      </Typography>
      <Box data-test-id="project-form-v2-project-terms">
        <TextFormField
          control={control}
          errors={formState.errors}
          name="projectTerms"
          multiline
          rows={6}
          placeholder={t('project.form.quote_pdf_terms_placeholder')}
        />
      </Box>
    </Card>
  );
}
